import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import * as columnFormatters from "../../components/column-formatters";
// import { Multiselect } from "multiselect-react-dropdown";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  ModalProgressBar,
} from "../../../_metronic/_partials/controls";
// import DeleteDialog from "../../components/DeleteDialog";
import { Formik, Form } from "formik";
// import * as Yup from "yup";
import { Col, Row } from "react-bootstrap";
import GamerjiTournamentSummeryDetails from "./GamerjiTournamentSummeryDetails";
// import moment from "moment";

import {
  sortCaret,
  headerSortingClasses,
} from "../../../_metronic/_helpers";

// import * as Yup from "yup";
// import BootstrapTable from "react-bootstrap-table-next";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from "react-responsive-carousel";

import * as UIHelpers from "../../components/UIHelpers";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

const GamerjiTournamentPointSummary = (props) => {
  const { id } = useParams();
  let history = useHistory();

  const suhbeader = useSubheader();
  const dispatch = useDispatch();

  const [reloadcount, setReloadcount] = useState(0);
  const [columns, setColumns] = useState([]);

  const [frmInitialValues, setFrmInitialValues] = useState({
    roomId: "",
    roomPassword: "",
    steamLink: "",
    numberOfPlayedUsers: 0,
    isActive: true,
  });

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );

  const {
    actionsLoading,
    // contestUsers,
    // listLoading,
    // tournamentForEdit,
    // tournamentRules,
    // bracketsImages,
    pointSummary,
    tounamentUsers,
    // tournamentPointPool,
    // tournamentPrizePool,
    pointSummaryActionsLoading
  } = currentState;

  useEffect(() => {
    dispatch(actions.fetchSingleTournament(id, true));
    // dispatch(actions.fetchTournamentRules(id));
    dispatch(actions.fetchGamerjiPointSummary(id));
    // dispatch(actions.fetchTournamentPointPool(id));
    // dispatch(actions.fetchTournamentPrizePool(id));
  }, [id, dispatch]);


  useEffect(() => {
    suhbeader.setTitle("Tournament Point Summary");
  }, [id]);

  // useEffect(() => {
  //   console.log("pointSummaryActionsLoading",pointSummaryActionsLoading)
  // }, [pointSummaryActionsLoading])

  useEffect(() => {
    console.log("here", pointSummary);
    var columns = [
      {
        dataField: "user",
        text: "User ID",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "uniqueIGN",
        text: "User Game Name",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
    ];
    if (id && pointSummary?.item) {
      const item = pointSummary.item;
      const data = { ...frmInitialValues, ...item };
      setFrmInitialValues(data);

      if (item && item.rounds && item.rounds.length > 0) {
        item.rounds.forEach((round, ind) => {
          columns.push({
            dataField: `R${ind + 1}RankPoint`,
            text: `Round ${ind + 1} (R${ind + 1}) Rank Points`,
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: columnFormatters.RoundDataColumnFormatter,
            formatExtraData: {
              dIndexName: `R${ind + 1}RankPoint`,
            },
          });
        });
      }
    }
    var tempColumn = [
      {
        dataField: "kills",
        text: "Total Kill",
        sort: false,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "totalKillPoints",
        text: "Total Kill Points",
        sort: false,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "totalRankPoints",
        text: "Total Rank Points",
        sort: false,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "trPoints",
        text: "Total Points",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "tpWiseRank",
        text: "Winning Rank By Points",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
      },
      {
        dataField: "tAmounts",
        text: "Total Amount",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.DecimalValueColumnFormatter,
      },
      {
        dataField: "isHacker",
        text: "Is Hacker",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        formatter: columnFormatters.HackerColumnFormatter,
      },
      {
        dataField: "tWiiningPrize",
        text: "Winning Prize",
        sort: true,
        sortCaret: sortCaret,
        headerSortingClasses,
        // formatter: columnFormatters.HackerColumnFormatter,
      },
    ];
    var newColumns = [...columns, ...tempColumn];
    setColumns(newColumns);

    suhbeader.setTitle("Tournament Info");
  }, [pointSummary, id]);

  // const GetNoOfMatches = (data) => {
  //   let noOfmatches = 0;
  //   if (data.rounds && data.rounds.length > 0) {
  //     data.rounds.forEach((round) => (noOfmatches += round.matches.length));
  //   }
  //   return noOfmatches;
  // };

  const saveWinning = () => {
    let users = [];

    tounamentUsers.forEach(async (user) => {
      users.push({
        // _id: user,
        amount: user.totalAmount,
        tAmounts: user.totalAmount,
        // contest: user.contest,
        // event: user.event,
        // createdAt: user.createdAt,
        // createdBy: user.createdBy,
        isHacking: user.isHacking,
        isHacker: user.isHacker,
        // game: user.game,
        // gameType: user.gameType,
        // isActive: user.isActive,
        // isDeleted: user.isDeleted,
        // kills: user.kills,
        // points: user.points,
        finalAmount: user.totalAmount,
        // team: user.team,
        // rankPoint: user.rankPoint,
        totalAmount: user.totalAmount,
        // uniqueIGN: user.uniqueIGN,
        // totalPoint: user.totalPoint,
        // totalRankPoints: user.totalRankPoints,
        // updatedAt: user.updatedAt,
        // updatedBy: user.updatedBy,
        // userId: user.user,
        points: user.points,
        rank: user.rank,
        user: user.user,
        companyCode: user.companyCode,
        isExtraPlayer: false,
      });
    })

    const params = {
      // event: pointSummary.item,
      // pointSummary: pointSummary,
      // tounamentUsers: tounamentUsers,
      tounamentUsers: users,
    };  
    // console.log("params-------------------------------------->",params)
    if (pointSummary && pointSummary.item && pointSummary.item._id) {
      const id = pointSummary.item._id;
      
      if (pointSummary.item?.prizePoolType === 'rewards') {
        // Display or call the reward-specific API
        
        dispatch(actions.updateGamerjiEventWinningsreward(params, id)).then((success) =>
          success ? history.push(`/tournaments/gamerji/view/${id}`) : null
        );
      } else {
        // Call the default API
        dispatch(actions.updateGamerjiEventWinnings(params, id)).then((success) =>
          success ?  history.push(`/tournaments/gamerji/view/${id}`) : null
        );
      }
      
    }
  };

  const reloadLocation = () => {
    setReloadcount(reloadcount + 1);
    window.location.reload();
  };

  return (
    <>
      {pointSummaryActionsLoading === true && 
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)", // semi-transparent white background
            zIndex: 9999, // ensure it's on top of other elements
          }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      }
      <NotificationContainer />
      {actionsLoading && <ModalProgressBar />}
      <div className="col-md-12">
        <GamerjiTournamentSummeryDetails type={"view"} />
      </div>

      {/* {pointSummary?.item && (
        <Col className="mb-4 col-md-12">
          <Card>
            <CardHeader title="Tournament Users"></CardHeader>
            <CardBody>
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                keyField="_id"
                data={tounamentUsers ? tounamentUsers : []}
                columns={columns}
                {...props}
              >
                <PleaseWaitMessage entities={tounamentUsers} />
                <NoRecordsFoundMessage entities={tounamentUsers} />
              </BootstrapTable>
              
            </CardBody>

            {pointSummary?.item?.status &&
              pointSummary.item.status === UIHelpers.CONTEST_STATUS.review && (
                <CardFooter className="text-right">
                  <button
                    type="button"
                    disabled={actionsLoading}
                    className="btn btn-primary"
                    onClick={() => saveWinning()}
                  >
                    {actionsLoading && (
                      <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    )}
                    Submit
                  </button>
                </CardFooter>
              )}
          </Card>
        </Col>
      )} */}

      {pointSummary && pointSummary?.item && (
        <>
          <Formik
            enableReinitialize={true}
            initialValues={frmInitialValues}
            onSubmit={(values) => {
              saveWinning(values);
            }}
          >
            {({
              handleSubmit,
              errors,
              values,
              setFieldValue,
              validateField,
              validateForm,
            }) => (
              <Form className="form form-label-right w-100">
                <Row>
                  <Col className="mb-4 col-md-12">
                    <Card>
                      <CardHeader title="Tournament Users"></CardHeader>
                      <CardBody>
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr>
                              <th>Sr No</th>
                              <th>USER ID</th>
                              <th>IS PREMIUM</th>
                              <th>USER GAME NAME</th>
                              {new Array(pointSummary?.item?.rounds).fill(1).map((round, index) => {
                                return (
                                  <th>
                                    Round {index + 1} R{index + 1} Rank Points
                                  </th>
                                );
                              })}
                              <th>Total Kill</th>
                              <th>Total Kill Points</th>
                              <th>Total Rank Points</th>
                              <th>Total Points</th>
                              <th>Winning Rank By Points</th>
                              <th>Total Amount</th>
                              <th>Winnings Amount with Multiplier</th>

                              <th>IS HACKER</th>
                              <th>WINNING PRIZE</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                            // pointSummary.item.status ===
                            // UIHelpers.CONTEST_STATUS.review
                            //   ? 
                              tounamentUsers.map((data, indp) => {
                                  return (
                                    <tr
                                      key={"rankPointtab" + indp}
                                      style={{
                                        backgroundColor: data.isHacker
                                          ? "#f64e60"
                                          : "",
                                      }}
                                    >
                                      <td>{indp + 1}</td>
                                      <td>{data.user}</td>
                                      <td>
                                        {data.isPremium ? (
                                          <img
                                            alt="icon"
                                            src={toAbsoluteUrl(
                                              "/media/logos/43825.png"
                                            )}
                                            className="max-h-50px"
                                          />
                                        ) : (
                                          "N/A"
                                        )}
                                      </td>
                                      <td>{data.uniqueIGN}</td>
                                      {new Array(pointSummary?.item?.rounds).fill(1).map((round, index) => {
                                            return (
                                              <td>
                                                <span className="d-block">
                                                  Rank :{" "}
                                                  {data?.roundArray[index]?.rank || 0}
                                                </span>
                                                <span className="d-block">
                                                  Points :{" "}
                                                  {data?.roundArray[index]?.point || 0}
                                                </span>
                                                <span className="d-block">
                                                  Kills :{" "}
                                                  {data?.roundArray[index]?.kill || 0}
                                                </span>
                                              </td>
                                            );
                                        })
                                      }

                                      <td>{data.kills}</td>
                                      <td>{data.totalKillPoint}</td>
                                      <td>{data.totalRankPoint}</td>
                                      <td>{data.points}</td>
                                      <td>{data.rank}</td>
                                      <td>{data.totalAmount}</td>
                                      <td>{data.totalMultiplierAmount}</td>
                                      <td>{data.isHacking ? "Yes" : "No"}</td>
                                      <td>{data.tWiiningPrize}</td>
                                    </tr>
                                  );
                                })
                              // : pointSummary?.tounamentUsers.map(
                              //     (data, indp) => {
                              //       return (
                              //         <tr
                              //           key={"rankPointtab" + indp}
                              //           style={{
                              //             backgroundColor: data.isHacker
                              //               ? "#f64e60"
                              //               : "",
                              //           }}
                              //         >
                              //           <td>{indp + 1}</td>
                              //           <td>{data.user}</td>
                              //           <td>
                              //             {data.isPremium ? (
                              //               <img
                              //                 alt="icon"
                              //                 src={toAbsoluteUrl(
                              //                   "/media/logos/43825.png"
                              //                 )}
                              //                 className="max-h-50px"
                              //               />
                              //             ) : (
                              //               "N/A"
                              //             )}
                              //           </td>
                              //           <td>{data.uniqueIGN}</td>
                              //           {console.log("data", indp, data)}
                              //           {pointSummary.item.rounds.map(
                              //             (round, index) => {
                              //               return (
                              //                 <td>
                              //                   <span className="d-block">
                              //                     Rank :{" "}
                              //                     {data[
                              //                       `R${index + 1}RankPoint`
                              //                     ].rank || 0}
                              //                   </span>
                              //                   <span className="d-block">
                              //                     Points :{" "}
                              //                     {data[
                              //                       `R${index + 1}RankPoint`
                              //                     ].points || 0}
                              //                   </span>
                              //                   <span className="d-block">
                              //                     Kills :{" "}
                              //                     {data[
                              //                       `R${index + 1}RankPoint`
                              //                     ].kills || 0}
                              //                   </span>
                              //                 </td>
                              //               );
                              //             }
                              //           )}

                              //           <td>{data.tKills}</td>
                              //           <td>{data.totalKillPoints}</td>
                              //           <td>{data.totalRankPoints}</td>
                              //           <td>{data.trPoints}</td>
                              //           <td>{data.tpWiseRank}</td>
                              //           <td>{data.tAmounts}</td>
                              //           <td>{data.totalMultiplierAmount}</td>
                              //           <td>{data.isHacker ? "Yes" : "No"}</td>
                              //           <td>{data.tWiiningPrize}</td>
                              //         </tr>
                              //       );
                                  }
                                {/* )} */}
                          </tbody>
                        </table>
                      </CardBody>
                      {pointSummary?.item?.status ===
                        UIHelpers.CONTEST_STATUS.review && (
                        <CardFooter className="text-right">
                          <button
                            type="button"
                            disabled={actionsLoading}
                            className="btn btn-primary"
                            onClick={() => saveWinning()}
                          >
                            {actionsLoading && (
                              <i
                                class="fa fa-spin fa-spinner"
                                aria-hidden="true"
                              ></i>
                            )}
                            Submit
                          </button>
                        </CardFooter>
                      )}
                    </Card>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </>
      )}
    </>
  );
};

export default GamerjiTournamentPointSummary;
